import React, { useEffect, useState } from "react";
import { TableBody, TableRow, TableCell, Radio } from "@mui/material";
import TableSkeleton from "../../operator/Components/TableSkeleton";

const cellStyle = {
  borderRight: "1px solid #ddd",
  py: 2,
  fontSize: "12px",
};

const factorNameCellStyle = {
  ...cellStyle,
  whiteSpace: "normal",
  wordBreak: "break-word",
  borderLeft: "1px solid #ddd",
};

function MatricesTableBody({
  data,
  onItemSelected,
  selectedRow,
  setSelectedRow,
  onIdsSelected,
  loading = false,
}) {
  const [selectedFactorId, setSelectedFactorId] = useState(null);

  // Handle selecting a row
  const handleSelect = (row) => {
    setSelectedRow(row);
    onItemSelected(row);
  };

  // Toggle selection of a factor ID (single selection for radio buttons)
  const toggleSelect = (factorId) => {
    setSelectedFactorId(factorId);
  };

  // Ensure at least one item is selected on component mount or data update
  useEffect(() => {
    if (Array.isArray(data) && data.length > 0 && !selectedFactorId) {
      toggleSelect(data[0]?.factorId);
    }
  }, [data]);

  // Update parent component with the selected item
  useEffect(() => {
    if (Array.isArray(data) && data.length > 0 && onIdsSelected) {
      const selectedItem = data.find(
        (item) => item?.factorId === selectedFactorId
      );
      onIdsSelected(selectedItem ? [selectedItem] : []);
    }
  }, [selectedFactorId, data, onIdsSelected]);

  return (
    <>
      <TableBody>
        {loading ? (
          <tr>
            <td colSpan="4">
              <TableSkeleton />
            </td>
          </tr>
        ) : (
          <>
            {!Array.isArray(data) ||
              (data.length === 0 && (
                <TableRow>
                  <TableCell sx={{ fontWeight: "500" }} colSpan={4}>
                    No data available
                  </TableCell>
                </TableRow>
              ))}
            {data?.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  cursor: "pointer",
                }}
              >
                <TableCell>
                  <span>
                    <Radio
                      size="small"
                      sx={{
                        color: "#B4B4B4",
                        padding: "0px",
                        "&.Mui-checked": {
                          color: row?.color || "#34A853",
                        },
                      }}
                      checked={selectedFactorId === row?.factorId}
                      onChange={() => toggleSelect(row?.factorId)}
                    />
                  </span>
                </TableCell>
                <TableCell sx={factorNameCellStyle}>
                  {row?.factorName}
                </TableCell>
                {/* <TableCell sx={cellStyle}>{row?.upperLimit || "NA"}</TableCell>
                <TableCell sx={cellStyle}>{row?.lowerLimit || "NA"}</TableCell> */}
                {/* <TableCell sx={cellStyle}>{row?.avgDeviation || "NA"}</TableCell> */}
              </TableRow>
            ))}
          </>
        )}
      </TableBody>
    </>
  );
}

export default MatricesTableBody;
